import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GamingPlatformComponent } from './gaming-platform.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [GamingPlatformComponent],
  exports: [GamingPlatformComponent]
})
export class GamingPlatformModule { }



// WEBPACK FOOTER //
// ./src/app/components/gaming-platform/gaming-platform.module.ts